<template>
  <div class="header">
    <router-link to="/main">
      <div class="logo">
        <img src="/interview/static/img/iwlogo.png" alt="">
      </div>
    </router-link>
    <div class="user">
      <div class="user_nm">{{cust_nm}}</div><!--
      --><v-icon @click="logout" v-bind:title="btn_title">exit_to_app</v-icon>
    </div>
  </div>
</template>

<script>
  import { mapMutations } from 'vuex'
  import { isLogin } from '@/assets/func'

  export default {
    name: 'header',
    data () {
      return {
        cust_nm: '',
        btn_title: 'LOG OUT',
        items: ['비밀번호 변경', 'LOG OUT'],
        menu_active: false,
        msg: 'LOGO'
      }
    },
    methods: {
      ...mapMutations([
        'clearCampaignList',
        'setLoginStatus'
      ]),
      logout () {
        sessionStorage.removeItem('iw_u')
        this.clearCampaignList()
        this.setLoginStatus(999)
        this.$router.push('/')
      }
    },
    created () {
      if (!isLogin()) {
        this.$router.push('/')
      } else {
        let data = JSON.parse(decodeURIComponent(atob(sessionStorage.getItem('iw_u'))))
        this.cust_nm = data.cust_nm
      }
    }
  }
</script>

<style scoped>
  .header {
    height: 50px;
    width: 100%;
    position: fixed;
    top: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-shadow: 0 0 2px 2px #ddd;
    z-index: 1;
    background: #fff;
  }
  .logo {
    width: 150px;
    text-align: center;
  }
  .logo img {
    vertical-align: middle;
    width: auto;
    height: auto;
    max-width: 150px;
    max-height: 50px;
  }
  
  .user {
    padding-right: 20px;
    height: 50px;
    position: absolute;
    display: flex;
    align-items: center;
    line-height: 50px;
    top: 0;
    right: 0;
  }
  .user .user_nm {
    font-family: sans-serif;
    font-size: 9pt;
    font-weight: 600;
    color: #505050;
    margin-right: 10px;
    white-space: nowrap;
  }
  .user i {
    font-size: 20pt;
    font-weight: 500;
    color: #6bafbd;
    vertical-align: middle;
  }
  .user i:hover {
    cursor: pointer;
  }

  @media screen and (max-width: 800px) {
    .header {
      width: 100% !important;
      height: 40px;
    }
    .logo img {
      max-height: 40px;
    }
    .user {
      height: 40px;
      line-height: 40px !important;
      padding-right: 10px;
    }
    .user .user_nm {
      margin-right: 5px;
    }
    .user i {
      font-size: 18pt;
      color: #6bafbd;
    }
  }
  @media screen and (max-width: 400px) {
    .user .user_nm {
      max-width: 110px;
      font-size: 9pt;
      margin-right: 5px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
</style>



// WEBPACK FOOTER //
// Header.vue?68a3cd31